export interface CustomVariable {
  key: string;
  value?: string | null;
}

export const extractUDKeys = (html: string | undefined): CustomVariable[] => {
  if (!html) return [];
  const udKeys: CustomVariable[] = [];
  const regex = /\{\{\{(UD_[a-zA-Z0-9]+)}}}/g;
  let match;

  while ((match = regex.exec(html)) !== null) {
    if (match[1]) udKeys.push({ key: match[1], value: null });
  }

  return udKeys;
};

export const processCustomVariables = (customVariables: CustomVariable[] | undefined) => {
  return customVariables?.map((customVariable) => {
    const { key, value } = customVariable;
    if (!value) return { key };
    return { key, value };
  });
};
